module.exports = __webpack_public_path__ + "img/amazon-square.36f3159c.svg";